import Combobox, { ComboboxOption } from '@/libs/components/src/lib/form/Combobox';
import { Muscle } from '@chiroup/core/types/Muscle.type';
import React, { Dispatch, SetStateAction, useMemo } from 'react';
import { REGION_OPTIONS } from '../../../../../constants';

type Props = {
  muscles: Muscle[];
  isFetchingMuscles?: boolean;
  value?: number[];
  onChangeMuscles: (muscles: number[]) => void;
  regions?: string[];
  setRegions: Dispatch<SetStateAction<string[]>> | ((val: string[]) => void);
  hideSelected?: boolean;
  whiteBackground?: boolean;
  disabled?: boolean;
};

const MuscleAutoCompleteMulti: React.FC<Props> = ({
  value = [],
  onChangeMuscles,
  regions,
  setRegions,
  isFetchingMuscles,
  muscles = [],
  hideSelected,
  whiteBackground,
  disabled,
}) => {
  const muscleOptions: ComboboxOption[] = useMemo(() => {
    const regionSelected = regions?.length;
    const musclesSeleted = muscles?.length;
    const options =
      regionSelected && musclesSeleted
        ? muscles?.filter(muscle => {
            const muscleSelected = value.includes(muscle.ID);
            const hasRegion = regions.some(region => muscle.regions?.includes(region));

            return muscleSelected || hasRegion;
          })
        : muscles;

    return options.map(muscle => {
      return { text: muscle.name, value: muscle.ID };
    });
  }, [muscles, regions, value]);

  return (
    <div
      className={`flex flex-col col-span-4 pt-4 pb-4 rounded-md gap-2 dark:bg-dark-gray-900 ${
        !whiteBackground && 'bg-gray-50 px-4'
      }`}
    >
      <div>
        <label
          className={['block text-sm font-medium leading-5 text-gray-900 dark:text-white'].join(
            ' '
          )}
        >
          Add muscles
        </label>
      </div>
      <Combobox
        name="regions"
        className="w-full"
        label="Filter muscles by region"
        value={regions}
        onChange={setRegions}
        options={REGION_OPTIONS}
        showLabel={false}
        disabled={disabled}
        placeholder="Filter muscles by region"
      />
      <Combobox
        name="muscles"
        className="w-full"
        label="Select muscles"
        value={value}
        onChange={onChangeMuscles}
        options={muscleOptions}
        loading={isFetchingMuscles}
        showLabel={false}
        disabled={disabled}
        placeholder="Select muscles"
      />
    </div>
  );
};

export default MuscleAutoCompleteMulti;
